export const statementActionType = {
  FETCH_CUSTOMER_STATEMENT_START: 'FETCH_CUSTOMER_STATEMENT_START',
  FETCH_CUSTOMER_STATEMENT_SUCCESS: 'FETCH_CUSTOMER_STATEMENT_SUCCESS',
  FETCH_CUSTOMER_STATEMENT_FAILED: 'FETCH_CUSTOMER_STATEMENT_FAILED',
};
